import { z } from 'zod'

import { ProductSpreadType } from '@enechain/eposition-proto/types/v1/deal_pb'

export const spreadTradeSchema = z.object({
  isSpreadTrade: z.boolean(),
  spreadType: z.array(z.nativeEnum(ProductSpreadType)).optional(),
  diffUnitPrice: z.string().optional(),
})

export type SpreadTradeSchema = z.input<typeof spreadTradeSchema>
